import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import { Jumbotron } from "./migration";
import Row from "react-bootstrap/Row";
import ProjectCard from "./ProjectCard";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
  languages: {}, // Add a placeholder for languages
};
const API = "https://api.github.com";

const Project = ({ heading, username, orgName, length, specific }) => {
  const allUserReposAPI = `${API}/users/${username}/repos?sort=updated&direction=desc`;
  const allOrgReposAPI = `${API}/orgs/${orgName}/repos?sort=updated&direction=desc`;
  const specificReposAPI = `${API}/repos/${username}`;
  const dummyProjectsArr = new Array(length + specific.length).fill(dummyProject);

  const [projectsArray, setProjectsArray] = useState([]);

  const fetchLanguages = async (repoUrl) => {
    try {
      const token = process.env.REACT_APP_GITHUB_TOKEN;
      const config = {
        headers: {
          Authorization: `token ${token}`,
        },
      };
      const response = await axios.get(`${repoUrl}/languages`, config);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch repo languages: ${error.message}`);
      return {};
    }
  };

  const fetchRepos = useCallback(async () => {
    let repoList = [];
    const token = process.env.REACT_APP_GITHUB_TOKEN;
    const config = {
      headers: {
        Authorization: `token ${token}`,
      },
    };

    const fetchAndStoreRepos = async () => {
      try {
        // getting all user repos
        if (username) {
          const userResponse = await axios.get(allUserReposAPI, config);
          repoList = [...userResponse.data.slice(0, length)];
          console.log("User Repos:", userResponse?.data);
        }
        console.log('orgname: ', orgName);
        // getting all org repos
        if (orgName) {
          const orgResponse = await axios.get(allOrgReposAPI, config);
          repoList = [...repoList, ...orgResponse.data.slice(0, 1)];
          console.log("Org Repos:", orgResponse?.data);
        }

        // adding specified repos
        for (let repoName of specific) {
          try {
            const response = await axios.get(`${specificReposAPI}/${repoName}`, config);
            const languages = await fetchLanguages(response.data.languages_url);
            repoList.push({ ...response.data, languages });
          } catch (error) {
            console.error(`Failed to fetch repo ${repoName}: ${error.message}`);
          }
        }

        // Store the fetched repositories in local storage
        localStorage.setItem('repos', JSON.stringify(repoList));
        localStorage.setItem('reposTimestamp', Date.now());
        setProjectsArray(repoList);
      } catch (error) {
        console.error(`Failed to fetch repos: ${error.message}`);
      }
    };

    // Check local storage for stored data
    const storedRepos = JSON.parse(localStorage.getItem('repos'));
    const storedTimestamp = localStorage.getItem('reposTimestamp');

    // Use stored data if it's less than 24 hours old
    if (storedRepos && storedTimestamp && Date.now() - storedTimestamp < 86400000) {
      console.log('Using cached repos from local storage');
      setProjectsArray(storedRepos);
    } else {
      await fetchAndStoreRepos();
    }
  }, [allUserReposAPI, allOrgReposAPI, length, specific, specificReposAPI, username, orgName]);

  useEffect(() => {
    fetchRepos();
  }, [fetchRepos]);

  return (
    <Jumbotron fluid id="projects" className="bg-light m-0">
      <Container>
        <h2 className="display-4 pb-5 text-center">{heading}</h2>
        <Row>
          {projectsArray.length
            ? projectsArray.map((project, index) => (
                <ProjectCard
                  key={`project-card-${index}`}
                  id={`project-card-${index}`}
                  value={project}
                />
              ))
            : dummyProjectsArr.map((project, index) => (
                <ProjectCard
                  key={`dummy-${index}`}
                  id={`dummy-${index}`}
                  value={project}
                />
              ))}
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default Project;
